import { Injectable } from '@angular/core';
import { environment } from './../environments/environment';

@Injectable()
export class Configuration {
    public Server: string = environment.api_url;
    public ApiUrl: string = 'api';
    public ServerWithApiUrl = this.Server + this.ApiUrl;
}
